import {
    Flex,
    Grid,
    GridProps,
    Text,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { Image } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';

export type GridCardProps = {
    label: string,
    src?: string,
    to: string,
} & GridProps & React.RefAttributes<HTMLDivElement>

export const GridCard: React.FC<GridCardProps> = ({
    label,
    src,
    to,
    ...props
}) => {
    const [open, setOpen] = useState(false);

    const onMouseEnter = () => setOpen(true);

    const onMouseLeave = () => setOpen(false);

    return (
        <Grid
            gap="2rem"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            cursor="pointer"
            position="relative"
            {...props}
        >
            <Link to={to}>
                <Grid
                    height="100%"
                    width="100%"
                    position="relative"
                    animation="fade-in 500ms ease-out"
                >
                    <Image
                        pos="absolute"
                        width="100%"
                        height="100%"
                        objectFit="cover"
                        src={src}
                    />
                    <Grid
                        height="100%"
                        gap="1rem"
                        zIndex={2}
                        padding="2rem"
                        margin="auto auto 0 0"
                        templateRows="1fr auto"
                        data-state={open ? 'open' : 'closed'}
                        transition="0.25s"
                        _open={{
                            margin: 'auto 0',
                            backdropFilter: 'blur(10px)',
                        }}
                        _closed={{
                            backdropFilter: 'blur(0px)',
                        }}
                    >
                        <Grid />
                        <Grid
                            data-state={open ? 'open' : 'closed'}
                            gap="0.5rem"
                            _open={{
                                animation: 'fade-in 500ms ease-out',
                            }}
                        >
                            <Flex wrap="wrap">
                                {label.split(' ').map((word) => (
                                    <Text fontWeight="900" fontSize="1.5rem" background="black" color="white" padding="0.25rem" width="fit-content">
                                        {word}
                                    </Text>
                                ))}
                            </Flex>
                            <Grid
                                data-state={open ? 'open' : 'closed'}
                                color="white"
                                overflow="hidden"
                                gap="1rem"
                                _open={{
                                    padding: '0.25rem',
                                    background: 'black',
                                    height: 'fit-content',
                                    animation: 'fade-in 0.25s ease-in',
                                }}
                                _closed={{
                                    padding: '0.25rem',
                                    height: 0,
                                    animation: 'fade-out 0.25s ease-out',
                                }}
                            >
                                <Grid templateColumns="auto 1fr" gap="0.5rem">
                                    <Text fontWeight="bold" textDecoration="underline">Подробнее</Text>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Link>
        </Grid>
    );
};
